import React, { useState, useEffect } from "react";
import { View, Text, Image, TouchableOpacity, Platform } from "react-native";
import CustomTextInput from "../../common/CustomTextInput";
import CustomButton from "../../common/CustomButton";
import IconBack from "../../assets/images/icon_back.png";
import ModalAlert from "../../common/ModalAlert";
import RadioButton from "../../common/RadioButton";
import applicationStyles from "../../styles/applicationStyles";
import DropdownArrow from "../../assets/images/dropdown_arrow.png";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import * as RootNavigation from "../../utilities/RootNavigation";
import {jwtDecode} from "jwt-decode";
import { priceBreakUp, isCommVehcle,} from "../../api/apiManager";
import {  getVehicleClass} from "../../api/serviceRequest";
import { policyDetails } from "../../api/tripInsurance";
import Loader from "../../common/Loader";
import PaymentScreen from "../../screens/payment/PaymentScreen";
import { isEmpty } from "lodash";
import useStyles from "./AddVehicle_Styles";
import {VEHICLE_NBR_TYPE} from "../../constant/dataHelper"
import ButtonWidget from "./Button_widget";
import CustomInput from "../../common/CustomInput";
import CInput from "../../common/CInput";
export default function AddVehicle(props) {
  const styles = useStyles();
  const [mode, setMode] = useState(0); //Mode 0 Initial, 1 Success, 2 Other Bank Active, 3 IDFC Blacklisted , 4 Otherbank Blacklisted
  const [check, setCheck] = useState(false);
  const [vehicleNbrType, setVehicleNbrType] = useState("RC Number");
  const [RCNumber, setRCNumber] = useState("");
  const [items, setItems] = useState("");
  const [policyData, setPolicyData] = useState({})
  const [stepThreeEnable, setStepThreeEnable] = useState(false);
  const [selectedLayout, setSelectedLayout] = useState("AddVehicle");
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({});
  const [verifyApiData, setVerifyApiData] = useState({});
  const [item, setItem] = useState();
  const [vcClassModal, setVcClassModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [childData, setChildData] = useState("");
  const [alertModal, setAlertModal] = useState({title: "", status: "", message: "", navigateScreen: "", actionButton: "", });

  useEffect(() => {
    if (!vcClassModal) {  getVehicleClasses(); }
    setAlertModal({title: "Error", status: "error", message: "res.message", navigateScreen: "", actionButton: "OK" });
    setAlertModalVisible(false);
    getPolicyDetails,setRCNumber(""); setMode(0); setStepThreeEnable(false); setApiData(""); setVerifyApiData(""); setSelectedLayout("Add Vehicle");
  }, []);
  useEffect(() => { setSelectedLayout(props.setSelectedItem);});

  const getPolicyDetails = () =>{
    policyDetails.then(res=>{ if(res?.statusCode == 1097) { setPolicyData(res?.data)}
    }).catch(err=>{})
}
  const onClickAddVehBtn = () => {
    if(isEmpty(policyData)){
      let reqObj = {
        vrn: RCNumber,
        vehicleClass: apiData?.commVeh != "" && apiData?.commVeh != undefined ? apiData?.commVeh : selectedItem,
        mobileNo: global?.applyNowMobile ? global.applyNowMobile : "",
        status: check,
        userId: token ? jwtDecode(token).mappedOrgId : "",
      };
      const obj = { ...props.data, ...{ addVehicleData: reqObj}, activeScrren : "Benifits",useCase:"Add-Vehicle"};
      RootNavigation.navigate("otherServices/insurance",obj)
    } else{ onClickAddVehBtnWithoutTI() }
  };
  const onClickAddVehBtnWithoutTI = async () => {
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let params = { status: check, userId: token ? jwtDecode(token).mappedOrgId :  "",};
    isCommVehcle(params)
      .then((res) => {
        if ((res.statusCode != 500 && res.statusCode > 0) || res.statusCode != -1033) {
          setVcClassModal(false);
          setLoading(true);
          let reqObj = {
            vrn: RCNumber,
            vehicleClass: (apiData?.commVeh!="" && apiData?.commVeh!=undefined)? apiData?.commVeh :selectedItem,
            mobileNo: global?.applyNowMobile ? global.applyNowMobile : "",
            tripInsurancePolicyCode:""
          };
          priceBreakUp(reqObj)
            .then((res) => {
              setLoading(false);
              if (res.message == "Success!" || res.statusCode == 200) {
                 setApiData(res.data);
                setItem(res.data);
                const obj = {...props.data,...{ addVehicleData: reqObj },...{priceBreakUpData:res.data},...{insuranceSkipped:true},...{fromScreen:"AddVehicle"}}
                props.setData(obj)
                props.setActiveScreen("PriceBreakup");
              }
              if (res.statusCode < 0 || res.statusCode == 500 || res.statusCode == -1033 ) {
                setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK",});
                setAlertModalVisible(true);
              } })
            .catch((err) => {
              setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK",});
              setAlertModalVisible(true);
              setLoading(false);
            });
        } else {
          setVcClassModal(false);
          setAlertModal({title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
        } setLoading(false);
      })
      .catch((err) => {
        setVcClassModal(false);
        setLoading(false);
        setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      });
  };
  const getVehicleClasses = () => {
    getVehicleClass()
      .then((res) => {
        if (res.statusCode != 500) {
          setItems(res?.data);
        } else {
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK" });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
      });};

  const toggleDropdown = () => setOpen(!isOpen);
  const handleItemClick = (vehicleClass) => {
    setOpen(false);
    setSelectedItem((prev) => (prev == vehicleClass ? "" : vehicleClass));
  };
  const getDropdownValue = () => {
    console.log(selectedItem, "selectedItem");
    return selectedItem && selectedItem != "" ? items.find((item) => item.vehicleClass === selectedItem).type : "Select ";
  };
  const onCloseModal = () => {  setAlertModalVisible(false);};

 
  return (
    <View style={styles.container}>
      {selectedLayout == 'Payment Screen' ? (
        <PaymentScreen
          setSelectedLayout={(layout) => setSelectedLayout(layout)}
          paymentData={item}
          vrn={RCNumber}
          passChildData={setChildData}
        />
      ) : selectedLayout == 'Personal Details' ? (
        <PersonalDetails setSelectedLayout={(layout) => setSelectedLayout(layout)} />
      ) : selectedLayout == 'Nominee Details' ? (
        <NomineeDetails setSelectedLayout={(layout) => setSelectedLayout(layout)} />
      ) : (
        <View style={{ width: '100%' }}>
          { !stepThreeEnable ? (
            <View style={styles.stepWidget}>
              <View style={styles.step1}>
                <View style={styles.backBtnWidget}>
                  <Text style={styles.widgetTitle}>{'Add Tag'}</Text>
                </View>
                <Text style={styles.stepDesk}> {'Enter the vehicle number and continue'} </Text>
                <View style={styles.inputBox}>
                  <View style={styles.rcInputViewStyle}>
                    <CInput
                      value={RCNumber.toUpperCase()}
                      onChangeText={(t) =>  setRCNumber(t)}
                      autoCapitalize={'characters'}
                      inputType='alpha-numeric'/>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                  <TouchableOpacity onPress={() => setCheck(!check)}>
                    <Image
                      source={check ? require('../../assets/images/Check_box_active.png') : require('../../assets/images/checkbox_default.png')}
                      style={{ height: 10, width: 10, marginRight: 5, resizeMode: 'center' }}
                    />
                  </TouchableOpacity>
                  <Text style={[styles.textStyle]}>{'Commercial Vehicle'}</Text>
                </View>
              </View>
              <View style={styles.step2}>
                <ButtonWidget 
                vehicleNbrType={vehicleNbrType}
                setVerifyApiData={setVerifyApiData} setStepThreeEnable={setStepThreeEnable}
                setLoading={setLoading} setMode={setMode} setAlertModal={setAlertModal}
                setAlertModalVisible={setAlertModalVisible} setApiData={setApiData}
                apiData={apiData} setVcClassModal={setVcClassModal} 
                RCNumber={RCNumber} mode = {mode} selectedItem={selectedItem}
                  />
              </View>
            </View>
          ) : (
            <View style={styles.stepWidget}>
              <View style={styles.step1}>
                <View style={styles.backBtnWidget}>
                  <TouchableOpacity
                    onPress={() => {
                      setStepThreeEnable(false);
                    }}>
                    <Image
                      source={IconBack}
                      style={{ height: 19, width: 19, marginLeft: -30, marginRight: 10 }}
                    />
                  </TouchableOpacity>
                  <Text style={styles.widgetTitle}>{'Add Tag'}</Text>
                </View>
                
              </View>
              <View style={[styles.step2]}>
                <Text style={styles.stepTitle}>{'Verify Details'}</Text>
                <Text style={styles.stepDesk}> {'Check the details and click Add vehicle'} </Text>
                <View style={[styles.tableData, { position: 'relative', zIndex: 999 }]}>
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableColumn, styles.wid40]}>{'Status'} </Text>
                    <Text style={[styles.tableColumn, styles.wid5]}>:</Text>
                    <Text style={[styles.tableColumn, styles.wid50, styles.statusColor]}> {verifyApiData?.npci_TagStatus || verifyApiData?.cardStage} </Text>
                  </View>
                  <View style={[styles.tableRow, { position: 'relative', zIndex: 999 }]}>
                    <Text style={[styles.tableColumn, styles.wid40]}> {'IDFC Tag Class'} </Text>
                    <Text style={[styles.tableColumn, styles.wid5]}>:</Text>
                    {apiData.vehicle_desc != '' && apiData.vehicle_desc != undefined ? (
                      <Text style={[applicationStyles.dropDownHeaderText, styles.wid50]}> {apiData.vehicle_desc}</Text>
                    ) : mode === 3 || mode === 4 ? (
                      <Text style={styles.wid50}> </Text>
                    ) : (
                      <View style={[applicationStyles.dropDownWidget, styles.wid50]}>
                        <View style={{}}>
                          <TouchableOpacity
                            onPress={toggleDropdown}
                            style={isOpen ? [applicationStyles.dropDownHeader, { width: 180, height: 32 }] : [applicationStyles.dropDownHeaderHide, { width: 180, height: 32 }]}>
                            <View style={{ flexDirection: 'row', width: '100%', alignItems: 'center', marginTop: 4, justifyContent: 'space-between' }}>
                              <Text
                                style={applicationStyles.dropDownHeaderText}
                                numberOfLines={1}
                                ellipsizeMode='tail'>
                                {getDropdownValue()}
                              </Text>
                              <Image
                                source={DropdownArrow}
                                style={applicationStyles.iconDropdown}
                              />
                            </View>
                          </TouchableOpacity>
                          <View
                            style={isOpen ? [applicationStyles.showDropdown, { top: 30, width: 180, height: 200, overflow: 'scroll' }] : applicationStyles.hideDropdown}
                            onBlur={() => setOpen(false)}>
                            {items &&
                              items?.map((item, index) => (
                                <TouchableOpacity
                                  onPress={(e) => handleItemClick(item.vehicleClass)}
                                  key={index}
                                  style={applicationStyles.listItems}>
                                  <Text style={applicationStyles.listItem}> {item.type} </Text>
                                </TouchableOpacity>
                              ))}
                          </View>
                        </View>
                      </View>
                    )}
                  </View>
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableColumn, styles.wid40]}>Vehicle </Text>
                    <Text style={[styles.tableColumn, styles.wid5]}>:</Text>
                    <Text style={[styles.tableColumn, styles.wid50]}>{apiData?.vehicle_name != '' ? apiData.vehicle_name : null} </Text>
                  </View>
                </View>
                {mode === 3 || mode === 4 ? (
                  <CustomButton
                    text={'Add Vehicle'}
                    disable={true}
                    style={styles.buttonAddVehicleDisable}
                  />
                ) : (
                  <CustomButton
                    onPress={onClickAddVehBtn}
                    text={'Add Vehicle'}
                    disable={true}
                    style={styles.buttonAddVehicle}
                  />
                )}
              </View>
            </View>
          )}
        </View>
      )}
      {loading && <Loader />}
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={'OK'}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
    </View>
  );}


